import { createSlice, combineReducers } from '@reduxjs/toolkit'
import { uccViewQueue } from './ucc-view.actions'

type InitialState<T> = {
  status: 'idle' | 'loading' | 'loaded' | ' failed'
  data: T | null
  error: string | null
}

const initialState: InitialState<unknown> = {
  status: 'idle',
  data: null,
  error: null,
}

const uccQueueSlice = createSlice({
  name: 'uccQueSlice',
  initialState,
  reducers: {},
  extraReducers: {
    [uccViewQueue.pending.toString()]: (state) => {
      state.status = 'loading'
      state.data = null
      state.error = null
    },
    [uccViewQueue.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
    },
    [uccViewQueue.rejected.toString()]: (state, action) => {
      state.status = ' failed'
      state.error = action.payload
    },
  },
})

export const uccReducers = combineReducers({
  uccQueue: uccQueueSlice.reducer,
})
